<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="mb-4">
                <h1 class="text-first">
                    {{ $t('Auth.SignUp.RouteName') }}
                </h1>
            </div>
            <form class="shadow rounded p-4" @submit.prevent="signUp">
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="name" class="border-bottom" id="name" :class="{ 'text-danger': errors.name }" required>
                        <label for="name" :class="{ 'text-danger': errors.name }">
                            <i class="fa-solid fa-user me-1"></i>
                            {{ $t('Auth.SignUp.name') }}
                            <small v-if="errors.name" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.name }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="surname" class="border-bottom" id="surname" :class="{ 'text-danger': errors.surname }" required>
                        <label for="surname" :class="{ 'text-danger': errors.surname }">
                            <i class="fa-solid fa-user me-1"></i>
                            {{ $t('Auth.SignUp.surname') }}
                            <small v-if="errors.surname" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.surname }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="email" class="border-bottom" id="email" :class="{ 'text-danger': errors.email }" required>
                        <label for="email" :class="{ 'text-danger': errors.email }">
                            <i class="fa-solid fa-envelope me-1"></i>
                            {{ $t('Auth.SignUp.email') }}
                            <small v-if="errors.email" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="confirm_email" class="border-bottom" id="confirm_email" :class="{ 'text-danger': errors.confirm_email }" required>
                        <label for="confirm_email" :class="{ 'text-danger': errors.confirm_email }">
                            <i class="fa-solid fa-envelope me-1"></i>
                            {{ $t('Auth.SignUp.confirm_email') }}
                            <small v-if="errors.confirm_email" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.confirm_email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="passwordShowed === false ? 'password' : 'text'" v-model="password" class="border-bottom" id="password" :class="{ 'text-danger': errors.password }" required>
                        <label for="password" :class="{ 'text-danger': errors.password }">
                            <i class="fa-solid fa-lock me-1"></i>
                            {{ $t('Auth.SignUp.password') }}
                            <small v-if="errors.password" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle" role="button" @click="passwordShowed = !passwordShowed">
                            <i class="fa-solid" :class="passwordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="confirmPasswordShowed === false ? 'password' : 'text'" v-model="confirm_password" class="border-bottom" id="confirm_password" :class="{ 'text-danger': errors.confirm_password }" required>
                        <label for="confirm_password" :class="{ 'text-danger': errors.confirm_password }">
                            <i class="fa-solid fa-lock me-1"></i>
                            {{ $t('Auth.SignUp.confirm_password') }}
                            <small v-if="errors.confirm_password" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.confirm_password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle" role="button" @click="confirmPasswordShowed = !confirmPasswordShowed">
                            <i class="fa-solid" :class="confirmPasswordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <label for="language" class="text-third" :class="{ 'text-danger': errors.language }">
                        <i class="fa-solid fa-language me-1"></i>
                        <span class="opacity-50">
                            {{ $t('Auth.SignUp.language') }}
                        </span>
                        <small v-if="errors.language" class="text-danger">
                            <span class="mx-2">
                                -
                            </span>
                            {{ errors.language }}
                        </small>
                    </label>
                    <LanguagesSelect id="language" class="d-flex align-items-center text-third" :class="{ 'text-danger': errors.language }" @setLanguage="$emit('selectLanguage', $event)" />
                </div>
                <div class="d-flex justify-content-center align-items-center mb-4">
                    <label class="switch me-2">
                        <input type="checkbox" v-model="privacy" @change="errors.privacy = null" />
                        <span class="slider round"></span>
                    </label>
                    <a href="https://www.bresciamobilita.it/privacy" target="_blank" class="text-underline"
                        :class="errors.privacy ? 'text-danger' : 'text-second'">
                        {{ $t('Auth.SignUp.privacy') }}
                    </a>
                    <small v-if="errors.privacy" class="text-danger">
                        <span class="mx-2">
                            -
                        </span>
                        {{ errors.privacy }}
                    </small>
                </div>
                <button type="submit" class="btn btn-auth btn-auth-third w-100 mb-4">
                    {{ $t('Auth.SignUp.sign_up') }}
                </button>
                <router-link to="/" class="text-second">
                    {{ $t('Auth.SignUp.go_back') }}
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'SignUp',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    data() {
        return {
            name: null,
            surname: null,
            email: null,
            confirm_email: null,
            password: null,
            confirm_password: null,
            passwordShowed: false,
            confirmPasswordShowed: false,
            privacy: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        signUp() {
            this.errors = {}
            if (this.privacy === false) {
                this.errors.privacy = this.$t('Auth.SignUp.errors.privacy.required')
                this.$toast.error(this.$t('toast.fields_errors'))
                return
            }
            this.$http
                .post(`${this.apiPath}/sign_up`, {
                    user: {
                        name: this.name,
                        surname: this.surname,
                        date_of_birth: null,
                        email: this.email,
                        confirm_email: this.confirm_email,
                        password: this.password,
                        confirm_password: this.confirm_password,
                        language: this.$i18n.locale,
                    }
                }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'user.name') {
                                this.errors.name = this.$t(`Auth.SignUp.errors.name.${error.msg}`)
                            }
                            if (error.path == 'user.surname') {
                                this.errors.surname = this.$t(`Auth.SignUp.errors.surname.${error.msg}`)
                            }
                            if (error.path == 'user.email') {
                                this.errors.email = this.$t(`Auth.SignUp.errors.email.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_email') {
                                this.errors.confirm_email = this.$t(`Auth.SignUp.errors.confirm_email.${error.msg}`)
                            }
                            if (error.path == 'user.password') {
                                this.errors.password = this.$t(`Auth.SignUp.errors.password.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_password') {
                                this.errors.confirm_password = this.$t(`Auth.SignUp.errors.confirm_password.${error.msg}`)
                            }
                            if (error.path == 'user.language') {
                                this.errors.language = this.$t(`Auth.SignUp.errors.language.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                    } else {
                        switch (res.data) {
                            case 'Account Already Exists':
                                this.errors.email = this.$t('Auth.SignUp.errors.email.AccountAlreadyExists')
                                this.$toast.error(this.$t('Auth.SignUp.errors.email.AccountAlreadyExists'))
                                break
                            case 'Account Registered Successfully':
                                this.$http
                                    .post(`${this.apiPath}/email/send_email_confirmation_request`, { email: this.email }, {
                                        headers: {
                                            'x-api-key': this.omsApiKey
                                        }
                                    }).then((res) => {
                                        this.$toast.success(`<h4>${this.$t('toast.signup_succeeded')}</h4> ${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong> <h6>${this.$t('toast.confirm_email')}</h6>`)
                                        this.$router.replace('/')
                                    })
                                    .catch((err) => {
                                        this.setErrorFromServer(err.message)
                                    })
                                break
                        }
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>